/**
 * Consistent typographic frame for legal / policy pages.
 * Uses architectural discipline: max-width prose column, ample whitespace,
 * gold hairlines on H2 markers, subtle blueprint grid on the side.
 */
export default function LegalLayout({ children }) {
  return (
    <section
      data-testid="legal-content"
      className="relative bg-white py-20 lg:py-28"
    >
      <div className="absolute inset-0 blueprint-grid opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-[900px] px-6 lg:px-10">
        <div className="legal-prose text-anthracite/85 font-light leading-relaxed text-[15.5px]">
          {children}
        </div>
      </div>
    </section>
  );
}
